module.exports = __webpack_public_path__ + "img/ueexbanner1.97c257ed.png";